var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowUpLong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333984 5.00004L1.27398 5.94004L4.33398 2.88671V13.6667H5.66732V2.88671L8.72732 5.94671L9.66732 5.00004L5.00065 0.333374L0.333984 5.00004Z",
    fill: "#312E40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowUpLong);
export default __webpack_public_path__ + "static/media/icon-arrow-up-long.08993516b5565134769b912fcf1e72ab.svg";
export { ForwardRef as ReactComponent };